const defaultState = {
  display: false,
  message: "",
  variant: ""
};

const alert = (state = defaultState, action) => {
  switch (action.type) {
    case "ALERT":
      return {
        variant: action.variant,
        message: action.message,
        display: true
      };
    case "CLOSE_ALERT":
      return { ...state, display: false };
    default:
      return state;
  }
};
export default alert;



// WEBPACK FOOTER //
// ./src/reducers/alert.js